import React from 'react';
import LastSeenCell from 'views/assets/AssetList/components/LastSeenCell';
import { Features } from 'types/config';
import BatteryCell from 'views/assets/AssetList/components/BatteryCell';
import { Asset } from 'types/asset';
import AssetStatusCell from 'views/assets/AssetList/components/AssetStatusCell';
import LocationCellAsset from 'views/assets/AssetList/components/LocationCellAsset';
import ArrowCell from 'components/DataTable/cells/ArrowCell';
import { Column } from 'components/DataTable/DataTable';

export function getAssetTableColumns(availableFeatureObj: Features): Column<Asset>[] {
  return [
    {
      title: 'ASSET NAME',
      width: '240px',
      field: 'asset_name',
    },
    {
      title: 'ASSET TYPE',
      width: '180px',
      field: 'asset_type',
      renderer: (cellValue: any) => cellValue.name
    },
    {
      title: 'ASSET ID',
      width: '230px',
      field: 'asset_id',
    },
    {
      title: 'STATUS',
      renderer: (cellValue, RowValues: Asset) => (
        <AssetStatusCell value={RowValues.status_assignment?.asset_status?.description} />
      ),
      width: '260px',
      field: 'status',
      hidden: !availableFeatureObj.asset_status,
    },
    {
      title: 'LOCATION',
      renderer: (cellValue, RowValues: Asset) => <LocationCellAsset value={RowValues} />,
      width: '260px',
      field: 'location',
    },
    {
      title: 'OWNER',
      field: 'owner',
      sortField: "asset_owner",
      width: '160px',
      renderer: (cellValue: any) => cellValue.name
    },
    {
      title: 'LAST SEEN',
      width: '140px',
      renderer: (cellValue, RowValues: Asset) => <LastSeenCell timestamp={RowValues.last_location_update_timestamp} />,
      field: 'last_update', // API is mapped to last_location_update_timestamp for last_update
    },
    {
      title: 'BATTERY',
      renderer: (cellValue: any, rowValues: Asset) => <BatteryCell {...rowValues} />,
      field: 'battery_level',
      width: '120px',
    },
    {
      title: "",
      noSort: true,
      renderer: () => <ArrowCell />,
      field: '',
      width: '10px',
    },
  ];
}
